import React, { useContext } from 'react';
import { useSelector } from 'react-redux';

import { translateWithI18Next } from '@kfc-global/kfc-i18n/lib';

import { UserOrderContext } from 'context/context';
import { getTernaryValue } from 'common/utilities/utils';
import { IMAGE_PATH } from 'common/ImageConstants/ImagePathUtils';
import { TRANSLATE_MAPPING_KEY } from 'common/constants/i18nTranslateKeys';
import { displayNotifyMessage } from 'common/sharedTemplates/sharedTemplates';
import { ClearCartModule } from 'organisms/ClearCartModule/Container/ClearCartComponent';
import { isMobileClassName, isMobilePadding, showCheckoutPageError } from 'common/utilities/CheckoutUtils';
import { CART, ROUTE_URL } from 'common/constants/SharedConstants';

const getChildElement = (childrenArray, side) => {
  return React.Children.map(childrenArray, child => {
    if (child?.props?.[side] && React.isValidElement(child)) {
      return React.cloneElement(child);
    }
    return null;
  });
};

const CheckoutViewHOC = props => {
  const { userOrderState } = useContext(UserOrderContext);
  const { orderReducer } = useSelector(data => {
    return data;
  });

  const childrenArray = React.Children.toArray(props?.children);

  const { isMobile } = props?.checkoutDetails;

  const { timeBasedAlertModalData } = userOrderState;
  return (
    <React.Fragment>
      <hr role='presentation' className='headerdivider' />
      <div className={`checkoutPagecont global`}>
        <div className={`checkoutContainer ${isMobileClassName(isMobile)}`} data-testid='checkout-page'>
          <img
            className='px-25px'
            alt='cart'
            src={getTernaryValue(isMobile, IMAGE_PATH.cart_header_mobile, IMAGE_PATH.Strips_Large_Cart)}
          />
          <div
            className={`checkoutHeader col-sm-7 col-md-12 col-lg-7 col-sm-12 mt-10px px-25px ${isMobilePadding(
              isMobile,
            )}`}
          >
            <div className={`d-flex align-items-baseline justify-content-between leftPanel`}>
              <h3 className={`checkoutTitle ${isMobileClassName(isMobile)}`}>
                {translateWithI18Next(TRANSLATE_MAPPING_KEY.CART_CHECKOUT)}
              </h3>
              <div className='secure-checkout'>
                <img src={IMAGE_PATH.LockIcon} alt='' />
                <span>{translateWithI18Next('secureCheckout')}</span>
              </div>
            </div>
          </div>
          {/* Display Dynamic Menu Item Unavailable Notify Message */}
          {timeBasedAlertModalData?.dynamicMenuAlertMessage && (
            <div
              col-mob-left
              col-left
              className='row-cols-12 mt-10px no-bg dynamicmenu-alert'
              data-testid='dynamicmenu-alert'
            >
              {displayNotifyMessage(
                <span className='dynamicmenu-alert-message'>
                  {translateWithI18Next(TRANSLATE_MAPPING_KEY?.CHECKOUT_UNAVAILABLE_ITEM)}{' '}
                  <a className='dynamicmenu-alert-cart-text' href={ROUTE_URL.CART}>
                    {CART}
                  </a>{' '}
                  {translateWithI18Next(TRANSLATE_MAPPING_KEY?.TO_CONTINUE)}
                </span>,
              )}
            </div>
          )}
          <div className={`checkoutBody ${isMobileClassName(isMobile)} row  mb-60px`}>
            <div className='checkoutDescDetails col-sm-12 col-lg-7 col-md-12 leftPanel'>
              {/* Payment Error display  Or  Creation Order Backend Error display */}
              {orderReducer &&
                showCheckoutPageError(orderReducer, props?.checkoutDetails, props?.updateCheckoutDetails)}
              {getChildElement(childrenArray, isMobile ? 'col-mob-left' : 'col-left')}
            </div>
            <div className={`mt-10px ${getTernaryValue(isMobile, 'py-25px mobile', '')} col-12 col-lg-5 rightPanel`}>
              {getChildElement(childrenArray, isMobile ? 'col-mob-right' : 'col-right')}
            </div>
          </div>
        </div>
      </div>
      {userOrderState.showCartClearAlert && <ClearCartModule />}
    </React.Fragment>
  );
};

export default CheckoutViewHOC;
